import { render } from "./TagMatrixData.vue?vue&type=template&id=1ba4377c&scoped=true"
import script from "./TagMatrixData.vue?vue&type=script&lang=js"
export * from "./TagMatrixData.vue?vue&type=script&lang=js"

import "./TagMatrixData.vue?vue&type=style&index=0&id=1ba4377c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba4377c"]])

export default __exports__